/**
 * Utility functions for formatting data
 */

/**
 * Format location data consistently
 * @param {Object|string} location - Location object or string
 * @returns {string} Formatted location string
 */
export const formatLocation = (location) => {
  if (typeof location === 'object' && location !== null) {
    return location.name ? 
      `${location.name}${location.region ? ` - ${location.region}` : ''}${location.country ? `, ${location.country}` : ''}` 
      : 'Location not specified';
  }
  return location || 'Location not specified';
};

/**
 * Format date to a readable string
 * @param {string} dateString - Date string
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};
